const REACT_APP_CLAIM_BASE_URL = process.env.REACT_APP_CLAIM_BASE_URL;

const fetchDataClaim = async ({ uri }: any) => {
  const response = await fetch(`${REACT_APP_CLAIM_BASE_URL}/${uri}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return await response.json();
};

export default fetchDataClaim;
